import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

import { IAssignmentStudentLearningObjective } from 'types'

// Extended description fields, in display order; empty ones are left out
const DETAIL_FIELDS: (keyof IAssignmentStudentLearningObjective)[] = [
  'mastery_criteria',
  'evidence_task_1',
  'evidence_task_2',
  'evidence_task_3',
  'evidence_task_4',
  'scaffold_supports',
  'teacher_prompt',
  'scaffold_fading_rule',
  'error_pattern',
  'recommended_response',
  'psychopedagogical_consideration',
  'instructional_consideration',
  'assessment_consideration',
  'differentiation_consideration',
  'developmental_consideration',
  'progression_consideration',
  'adaptive_learning_consideration',
]

interface IProps {
  objectives?: IAssignmentStudentLearningObjective[]
}

const StudentLearningObjectivesAccordion: FC<IProps> = ({ objectives }) => {
  const { t } = useTranslation()

  if (!objectives?.length) return null

  return (
    <Box sx={{ width: '100%', marginBottom: '40px' }}>
      {objectives.map(slo => (
        <Accordion key={'slo_' + slo.id} TransitionProps={{ unmountOnExit: true }}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>
              {slo.title}{' '}
              <Typography component="span" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                ({t('slo-details.general-guidance')})
              </Typography>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* Fixed-width label column, so all values line up */}
            <Box sx={{ display: 'grid', gridTemplateColumns: '260px 1fr', columnGap: '20px', rowGap: '10px' }}>
              {DETAIL_FIELDS.filter(field => slo[field]).map(field => (
                <Fragment key={field}>
                  <Typography sx={{ color: 'black', fontWeight: 700 }}>{t(`slo-details.${field}`)}</Typography>
                  <Typography sx={{ whiteSpace: 'pre-line' }}>{slo[field]}</Typography>
                </Fragment>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  )
}

export default StudentLearningObjectivesAccordion
